import { render, staticRenderFns } from "./CampaignApplications.vue?vue&type=template&id=bc74d288&"
import script from "./CampaignApplications.vue?vue&type=script&lang=js&"
export * from "./CampaignApplications.vue?vue&type=script&lang=js&"
import style0 from "./CampaignApplications.vue?vue&type=style&index=0&id=bc74d288&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports